export function buildParams({ page, limit, sorter, search, searchColumns, filters }) {
  let order = {};
  let searchParams = {};
  let params = { page, limit };

  if (sorter) {
    order["order[" + sorter.column + "]"] = sorter.direction;
  }

  if (search && search.length) {
    search.forEach((value) => {
      searchColumns.forEach((c, i) => {
        searchParams = {
          ...searchParams,
          ['search[' + i + '][column]']: c.column,
          ['search[' + i + '][values][' + i +']']: value
        }
      });
    });
  }

  params = {
    ...params,
    ...order,
    ...searchParams,
    ...(filters && filters)
  };

  return params;
}